"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PageIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="page-introduction" className="relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden bg-background py-24 md:py-32" ref={ref}>
      {}
      <div className="pointer-events-none absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/service_area_map_watermark.png)] bg-cover bg-center bg-no-repeat opacity-[0.02]" aria-hidden="true" />

      <div className="container relative z-10 mx-auto flex flex-col items-center px-4 text-center">
        {}
        <div className={`flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "scale-100 opacity-100" : "scale-105 opacity-0"}`}>
          <h1 className="font-sans text-4xl font-extrabold leading-tight tracking-normal text-foreground md:text-[4rem]">
            Dedicated to Our Region
          </h1>
          {}
          <div className="mt-6 h-1 w-24 rounded-full bg-primary" />
        </div>

        {}
        <p className={`mt-8 max-w-[700px] font-sans text-lg font-medium leading-[1.6] text-muted-foreground transition-all duration-1000 delay-300 ease-out md:text-xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          We are committed to delivering exceptional service across our entire coverage area. Experience the difference of a team that truly understands and values the communities we serve.
        </p>
      </div>
    </section>;
}